import axios from 'axios'

export default {
  namespaced: true,
  state: {
    levels: []
  },
  mutations: {
    SET_LIST (state, data) {
      state.levels = data
    }
  },
  getters: {},
  actions: {
    async get ({ commit }) {
      let data = await axios.get('/levels')
      commit('SET_LIST', data.data)
    }
  }
}
